
let wasm;

const heap = new Array(32).fill(undefined);

heap.push(undefined, null, true, false);

function getObject(idx) { return heap[idx]; }

let heap_next = heap.length;

function dropObject(idx) {
    if (idx < 36) return;
    heap[idx] = heap_next;
    heap_next = idx;
}

function takeObject(idx) {
    const ret = getObject(idx);
    dropObject(idx);
    return ret;
}

let cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });

cachedTextDecoder.decode();

let cachegetUint8Memory0 = null;
function getUint8Memory0() {
    if (cachegetUint8Memory0 === null || cachegetUint8Memory0.buffer !== wasm.memory.buffer) {
        cachegetUint8Memory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachegetUint8Memory0;
}

function getStringFromWasm0(ptr, len) {
    return cachedTextDecoder.decode(getUint8Memory0().subarray(ptr, ptr + len));
}

function addHeapObject(obj) {
    if (heap_next === heap.length) heap.push(heap.length + 1);
    const idx = heap_next;
    heap_next = heap[idx];

    heap[idx] = obj;
    return idx;
}

let WASM_VECTOR_LEN = 0;

let cachedTextEncoder = new TextEncoder('utf-8');

const encodeString = (typeof cachedTextEncoder.encodeInto === 'function'
    ? function (arg, view) {
    return cachedTextEncoder.encodeInto(arg, view);
}
    : function (arg, view) {
    const buf = cachedTextEncoder.encode(arg);
    view.set(buf);
    return {
        read: arg.length,
        written: buf.length
    };
});

function passStringToWasm0(arg, malloc, realloc) {

    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length);
        getUint8Memory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len);

    const mem = getUint8Memory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }

    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3);
        const view = getUint8Memory0().subarray(ptr + offset, ptr + len);
        const ret = encodeString(arg, view);

        offset += ret.written;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}

let cachegetInt32Memory0 = null;
function getInt32Memory0() {
    if (cachegetInt32Memory0 === null || cachegetInt32Memory0.buffer !== wasm.memory.buffer) {
        cachegetInt32Memory0 = new Int32Array(wasm.memory.buffer);
    }
    return cachegetInt32Memory0;
}

const u32CvtShim = new Uint32Array(2);

const uint64CvtShim = new BigUint64Array(u32CvtShim.buffer);
/**
* Represents the simulation context which exposes an interface of the
* simulation as well as helpers for rendering the simulation
*/
export class SnowflakeSimContext {

    static __wrap(ptr) {
        const obj = Object.create(SnowflakeSimContext.prototype);
        obj.ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_snowflakesimcontext_free(ptr);
    }
    /**
    * @param {number} width
    * @param {number} height
    * @param {number} alpha
    * @param {number} beta
    * @param {number} gamma
    * @returns {SnowflakeSimContext}
    */
    static new(width, height, alpha, beta, gamma) {
        var ret = wasm.snowflakesimcontext_new(width, height, alpha, beta, gamma);
        return SnowflakeSimContext.__wrap(ret);
    }
    /**
    * Set the water level of a cell
    * @param {number} x
    * @param {number} y
    * @param {number} water
    */
    set_cell(x, y, water) {
        wasm.snowflakesimcontext_set_cell(this.ptr, x, y, water);
    }
    /**
    * Step the Snowflake simulation one iteration
    */
    step_simulation() {
        wasm.snowflakesimcontext_step_simulation(this.ptr);
    }
    /**
    */
    init_tracking() {
        wasm.snowflakesimcontext_init_tracking(this.ptr);
    }
    /**
    * Initiate the playback of a simulation
    * @param {string} sim_repr_str
    */
    init_playback(sim_repr_str) {
        var ptr0 = passStringToWasm0(sim_repr_str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        wasm.snowflakesimcontext_init_playback(this.ptr, ptr0, len0);
    }
    /**
    * Step the Snowflake simulation one iteration based on the playback
    */
    step_simulation_playback() {
        wasm.snowflakesimcontext_step_simulation_playback(this.ptr);
    }
    /**
    * Get a string representation of the simulation
    * which allows for playback.
    * @returns {string}
    */
    get_simulation_string_repr() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.snowflakesimcontext_get_simulation_string_repr(retptr, this.ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(r0, r1);
        }
    }
    /**
    * Create the vertex position buffer representing
    * the hexagonal simulation
    */
    create_vertex_positions() {
        wasm.snowflakesimcontext_create_vertex_positions(this.ptr);
    }
    /**
    * Get the amount of vertices in the vertex position buffer
    * for the simulation
    * @returns {number}
    */
    get_vertex_count() {
        var ret = wasm.snowflakesimcontext_get_vertex_count(this.ptr);
        return ret >>> 0;
    }
    /**
    * Update the vertex color buffer based on the
    * current state of the simulation.
    */
    update_vertex_colors() {
        wasm.snowflakesimcontext_update_vertex_colors(this.ptr);
    }
    /**
    * @returns {Float32Array}
    */
    get_vertex_positions() {
        var ret = wasm.snowflakesimcontext_get_vertex_positions(this.ptr);
        return takeObject(ret);
    }
    /**
    * @returns {Float32Array}
    */
    get_vertex_colors() {
        var ret = wasm.snowflakesimcontext_get_vertex_colors(this.ptr);
        return takeObject(ret);
    }
    /**
    * Set the alpha (vapor diffusion) parameter of the Snowflake Simulation
    * @param {number} value
    */
    set_alpha(value) {
        wasm.snowflakesimcontext_set_alpha(this.ptr, value);
    }
    /**
    * Set the beta (background_vapor) parameter of the Snowflake Simulation
    * @param {number} value
    */
    set_beta(value) {
        wasm.snowflakesimcontext_set_beta(this.ptr, value);
    }
    /**
    * Set the gamma (vapor_addition) parameter of the Snowflake Simulation
    * @param {number} value
    */
    set_gamma(value) {
        wasm.snowflakesimcontext_set_gamma(this.ptr, value);
    }
    /**
    * Set the alpha randomization value of the Snowflake Simulation
    * * `range` - the percentage range of the random change of the parameter
    * @param {number} range
    */
    set_alpha_rand(range) {
        wasm.snowflakesimcontext_set_alpha_rand(this.ptr, range);
    }
    /**
    * Set the beta randomization value of the Snowflake Simulation
    * * `range` - the percentage range of the random change of the parameter
    * @param {number} range
    */
    set_beta_rand(range) {
        wasm.snowflakesimcontext_set_beta_rand(this.ptr, range);
    }
    /**
    * Set the gamma randomization value of the Snowflake Simulation
    * * `range` - the percentage range of the random change of the parameter
    * @param {number} range
    */
    set_gamma_rand(range) {
        wasm.snowflakesimcontext_set_gamma_rand(this.ptr, range);
    }
    /**
    * Set the random seed of the simulation
    * @param {BigInt} seed
    */
    set_random_seed(seed) {
        uint64CvtShim[0] = seed;
        const low0 = u32CvtShim[0];
        const high0 = u32CvtShim[1];
        wasm.snowflakesimcontext_set_random_seed(this.ptr, low0, high0);
    }
    /**
    * Set whether the background should be transparent or not
    * @param {boolean} value
    */
    set_transparent_background(value) {
        wasm.snowflakesimcontext_set_transparent_background(this.ptr, value);
    }
    /**
    * @returns {number}
    */
    get_alpha() {
        var ret = wasm.snowflakesimcontext_get_alpha(this.ptr);
        return ret;
    }
    /**
    * @returns {number}
    */
    get_beta() {
        var ret = wasm.snowflakesimcontext_get_beta(this.ptr);
        return ret;
    }
    /**
    * @returns {number}
    */
    get_gamma() {
        var ret = wasm.snowflakesimcontext_get_gamma(this.ptr);
        return ret;
    }
    /**
    * @returns {number}
    */
    get_alpha_rand() {
        var ret = wasm.snowflakesimcontext_get_alpha_rand(this.ptr);
        return ret;
    }
    /**
    * @returns {BigInt}
    */
    get_seed() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.snowflakesimcontext_get_seed(retptr, this.ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            u32CvtShim[0] = r0;
            u32CvtShim[1] = r1;
            const n0 = uint64CvtShim[0];
            return n0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

async function load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming === 'function') {
            try {
                return await WebAssembly.instantiateStreaming(module, imports);

            } catch (e) {
                if (module.headers.get('Content-Type') != 'application/wasm') {
                    console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);

                } else {
                    throw e;
                }
            }
        }

        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);

    } else {
        const instance = await WebAssembly.instantiate(module, imports);

        if (instance instanceof WebAssembly.Instance) {
            return { instance, module };

        } else {
            return instance;
        }
    }
}

async function init(input) {
    if (typeof input === 'undefined') {
        input = new URL('index_bg.wasm', import.meta.url);
    }
    const imports = {};
    imports.wbg = {};
    imports.wbg.__wbindgen_object_drop_ref = function(arg0) {
        takeObject(arg0);
    };
    imports.wbg.__wbg_buffer_397eaa4d72ee94dd = function(arg0) {
        var ret = getObject(arg0).buffer;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_newwithbyteoffsetandlength_8bd669b4092b7244 = function(arg0, arg1, arg2) {
        var ret = new Float32Array(getObject(arg0), arg1 >>> 0, arg2 >>> 0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_new_8b45a9becdb89691 = function(arg0) {
        var ret = new Float32Array(getObject(arg0));
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_throw = function(arg0, arg1) {
        throw new Error(getStringFromWasm0(arg0, arg1));
    };
    imports.wbg.__wbindgen_memory = function() {
        var ret = wasm.memory;
        return addHeapObject(ret);
    };

    if (typeof input === 'string' || (typeof Request === 'function' && input instanceof Request) || (typeof URL === 'function' && input instanceof URL)) {
        input = fetch(input);
    }



    const { instance, module } = await load(await input, imports);

    wasm = instance.exports;
    init.__wbindgen_wasm_module = module;

    return wasm;
}

export default init;

